import { PropsWithChildren, createContext, useState } from "react";

export const GlobalContext = createContext<{
  flagOverrides: Record<string, string>;
}>({
  flagOverrides: {}
});

export const GlobalProvider = ({ children }: PropsWithChildren) => {
  const [flagOverrides, setFlagOverrides] = useState({});
  const value = {
    flagOverrides,
    setFlagOverrides
  };

  return (
    <GlobalContext.Provider value={value}>{children}</GlobalContext.Provider>
  );
};
